import { Component, Vue } from 'vue-property-decorator';
import { CreateElement } from 'vue';
import { VIcon } from 'vuetify/lib';

@Component({
  name: 'CloseButton',
})
export default class CloseButton extends Vue {
  private render(createElement: CreateElement) {
    return createElement(VIcon, '$vuetify.icons.close_button');
  }
}
